import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/model-management/{-$id}/')({
  validateSearch: zodValidator(withDefaults(schema.MODEL_MANAGEMENT, defaultFilter)),
});
